import React, { useMemo } from 'react';
// @ts-ignore: TS2459 — we know it's there at runtime
import { DailyPerformanceCard } from '@PikaDoApp/pikado-web-dsm';

interface DailyPerformanceContainerProps {
  studentsDailyAveragesInClassThisMonth:any[],
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
}

export const DailyPerformanceContainer: React.FC<DailyPerformanceContainerProps> = ({
  studentsDailyAveragesInClassThisMonth,
  selectedMonth,
  onMonthChange,
  monthOptions,
}) => {

  const dailyPerformanceData = useMemo(() => {
    const dataMap = new Map<number, number>();

    // Validate input array
    const validInput = Array.isArray(studentsDailyAveragesInClassThisMonth)
      ? studentsDailyAveragesInClassThisMonth
      : [];

    if (validInput.length > 0) {
      validInput.forEach((d: any) => {
        // Validate both day and average are present and valid
        if (d && typeof d.day === 'number' && Number.isFinite(d.day)) {
          // Ensure we only store valid, finite numbers
          const average = (d.average !== null && d.average !== undefined && Number.isFinite(d.average))
            ? d.average
            : 0;
          dataMap.set(d.day, average);
        }
      });
    }

    // Generate all 31 days, filling missing days with 0
    const allDays = [];
    for (let day = 1; day <= 31; day++) {
      const performance = dataMap.get(day);
      allDays.push({
        date: day.toString(),
        performance: Number.isFinite(performance) ? performance : 0,
      });
    }

    return allDays;
  }, [studentsDailyAveragesInClassThisMonth]);

  return (
    <DailyPerformanceCard
      dailyPerformanceData={dailyPerformanceData}
      title="Daily Performance "
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
    />
  );
};
